import ImpressComponent from '@wix/thunderbolt-elements/src/components/Impress/viewer/Impress';
import ImpressController from '@wix/thunderbolt-elements/src/components/Impress/viewer/Impress.controller';


const Impress = {
  component: ImpressComponent,
  controller: ImpressController
};


export const components = {
  ['Impress']: Impress
};

